import { EmissionCustomReportListTab } from "#batteries-included-components/Tabs/CustomReports/EmissionCustomReportListTab";
import { useSearchParams } from "#routers/hooks";
import {
  CustomReportsListRoutePath,
  CustomReportsListRouteTabs,
} from "#routes/reports/custom-reports/index";
import { RecordCustomReportListTab } from "#src/batteries-included-components/Tabs/CustomReports/RecordCustomReport";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Page, Tab } from "@validereinc/common-components";
import React from "react";

export const CustomReportListPage = () => {
  const [{ tab }, setSearchParams] = useSearchParams();
  const [breadcrumbs] = useBreadcrumbsFromRoute(CustomReportsListRoutePath);
  const [isRecordsReportingEnabled] = useIsFeatureAvailable({
    featureFlagQuery: {
      $and: [
        { $or: ["core:facilities", "core:equipment", "core:flows"] },
        "core:volumetric_reporting",
      ],
    },
    permissionQuery: {
      $and: [
        { $or: ["facilities:read", "equipment:read", "flows:read"] },
        "records:read",
        "volumetric_reporting:read",
      ],
    },
  });
  const [isEquipmentEmissionsEnabled] = useIsFeatureAvailable({
    featureFlagQuery: "core:equipment",
    permissionQuery: { $and: ["equipment:read", "calculator_results:read"] },
  });

  return (
    <Page
      category={CustomReportsListRoutePath.subtitle}
      title={CustomReportsListRoutePath.title}
      breadcrumbs={breadcrumbs}
      activeTabKey={
        tab ??
        (isRecordsReportingEnabled
          ? CustomReportsListRouteTabs.RecordsTab
          : CustomReportsListRouteTabs.EmissionsTab)
      }
      onActiveTabKeyChange={(tab) => setSearchParams({ tab })}
    >
      {isRecordsReportingEnabled ? (
        <Tab
          title="Records"
          tabKey={CustomReportsListRouteTabs.RecordsTab}
        >
          <RecordCustomReportListTab />
        </Tab>
      ) : null}
      {isEquipmentEmissionsEnabled ? (
        <Tab
          title="Emissions"
          tabKey={CustomReportsListRouteTabs.EmissionsTab}
        >
          <EmissionCustomReportListTab />
        </Tab>
      ) : null}
    </Page>
  );
};
